export const environment = {
  environment: 'staging',
  positizeHubUrl: 'https://hub.staging.positize.app',
  // French secured cash-register mode offered in the onboarding (staging only until attested)
  fiscalModeFrEnabled: true,
};
